import { esgCollaborationStore } from "../stores/report/esg-collaboration.store";
import { esgDataEntryStore } from "../stores/report/esg-data-entry.store";
import { esgDisclosureSelectionStore } from "../stores/report/esg-disclosure-selection.store";
import { esgReportBuilderStore } from "../stores/report/esg-report-builder.store";
import { esgReportWorkflowStore } from "../stores/report/esg-report-workflow.store";

export const useESGReportWorkflowStore = () => esgReportWorkflowStore;
export const useESGReportBuilderStore = () => esgReportBuilderStore;
export const useESGDisclosureSelectionStore = () => esgDisclosureSelectionStore;
export const useESGDataEntryStore = () => esgDataEntryStore;
export const useESGCollaborationStore = () => esgCollaborationStore;
